import { useState, useEffect } from "react";
import { AlertTriangle, X } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function VoteAlertBanner() {
  const [alert, setAlert] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/api/vote-alert`)
      .then((res) => {
        if (res.data.active && res.data.message) {
          const stored = localStorage.getItem("vote_alert_dismissed");
          if (stored !== res.data.message) {
            setAlert(res.data);
          } else {
            setDismissed(true);
          }
        }
      })
      .catch(() => {});
  }, []);

  const handleDismiss = () => {
    if (alert) {
      localStorage.setItem("vote_alert_dismissed", alert.message);
    }
    setDismissed(true);
  };

  if (!alert || dismissed) return null;

  return (
    <div
      className="relative z-50 bg-orange-600 text-white"
      data-testid="vote-alert-banner"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <AlertTriangle className="w-5 h-5 flex-shrink-0" />
          <p className="text-sm font-medium truncate" data-testid="vote-alert-text">
            {alert.message}
          </p>
        </div>
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 p-1 rounded-full hover:bg-orange-700 transition-colors"
          data-testid="vote-alert-dismiss"
          aria-label="Dismiss alert"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
